import React, { ChangeEvent } from 'react';

import { PasswordInputProps } from '../components/PasswordInput';

/* eslint-disable no-useless-escape */
function isValidPassword(password: string): boolean {
  const regex =
    /^(?=.*[A-Za-z])(?=.*\d)(?=.*[!@#$%^&*()_+{}\[\]:;<>,.?/~`"'\\|=])[A-Za-z\d!@#$%^&*()_+{}\[\]:;<>,.?/~`"'\\|=]{8,16}$/;

  return regex.test(password);
}
/* eslint-enable no-useless-escape */

const useUpdatePasswordInputProps = (
  currPw: string = '',
  newPw: string = '',
  confirmPw: string = '',
  onPwChange: (pw: string) => void,
  onNewPwChange: (pw: string, confirm: string) => void
) => {
  const [newPwError, setNewPwError] = React.useState<boolean>(false);
  const [confirmPwError, setConfirmPwError] = React.useState<boolean>(false);
  const currPwRef = React.useRef<HTMLInputElement>(null);

  const handleCurrPwChange = (e: ChangeEvent<HTMLInputElement>) => {
    onPwChange(e.target.value);
  };

  const checkConfirmPw = () => {
    if (confirmPw) {
      setConfirmPwError(newPw !== confirmPw);
    }
  };

  const checkNewPw = () => {
    if (confirmPw) {
      setConfirmPwError(newPw !== confirmPw);
    }

    setNewPwError(!isValidPassword(newPw));
  };

  const handleNewPwChange = (e: ChangeEvent<HTMLInputElement>) => {
    onNewPwChange(e.target.value, confirmPw);
  };

  const handleConfirmPwChange = (e: ChangeEvent<HTMLInputElement>) => {
    onNewPwChange(newPw, e.target.value);
    setConfirmPwError(false);
  };

  const currPwProps = {
    size: 'lg',
    fullWidth: true,
    required: true,
    label: '현재 비밀번호',
    placeholder: '현재 비밀번호 입력',
    value: currPw,
    onChange: handleCurrPwChange,
    slotProps: {
      input: { autoComplete: 'new-password', ref: currPwRef, type: 'password', maxLength: 16, minLength: 8 },
    },
  } as PasswordInputProps;

  const newPwProps = {
    size: 'lg',
    fullWidth: true,
    required: true,
    error: !!newPwError,
    label: '새 비밀번호',
    helperText: '* 영문, 숫자, 특수문자를 포함한 8~16자로 입력하세요.',
    placeholder: '새 비밀번호 입력',
    value: newPw,
    onChange: handleNewPwChange,
    onBlur: checkNewPw,
    slotProps: { input: { autoComplete: 'new-password', type: 'password', maxLength: 16, minLength: 8 } },
  } as PasswordInputProps;

  const confirmPwProps = {
    size: 'lg',
    fullWidth: true,
    required: true,
    error: !!confirmPwError,
    label: '새 비밀번호 확인',
    helperText: confirmPwError ? '비밀번호가 일치하지 않습니다' : '',
    placeholder: '새 비밀번호 재입력',
    value: confirmPw,
    onChange: handleConfirmPwChange,
    onBlur: checkConfirmPw,
    slotProps: {
      input: { autoComplete: 'new-password', type: 'password', maxLength: 16, minLength: 8 },
    },
  } as PasswordInputProps;

  const resetErrors = () => {
    setNewPwError(false);
    setConfirmPwError(false);
  };

  const isValid = currPw.length > 0 && newPw.length >= 8 && confirmPw.length >= 8 && !confirmPwError && !newPwError;

  return {
    currPwProps,
    newPwProps,
    confirmPwProps,
    currPwRef,
    isValid,
    resetErrors,
  };
};

export default useUpdatePasswordInputProps;
